import {
  ON_CHANGE_FEED_GALLERY,
  ON_CHANGE_HASHTAG_GALLERY,
  EMPTY_ACCOUNT_HEIGHT,
  LOADING_MEDIAS_HEIGHT,
} from '../../constants';
import {
  DEFAULT_SHOW_MORE_HEIGHT,
  GALLERY_TYPES,
  COLLAGE_LAYOUTS_OPTIONS,
} from '../../constants/proGalleryConstants';
import {
  LAYOUTS,
  STYLE_PARAMS_BY_LAYOUTS,
  STYLE_PARAMS_BY_LAYOUTS_HASHTAG,
} from '../../constants/settingsConstants';
import { getCurrentSettings } from './gallerySettings';
import store from '../../store';
import { updateCollageHeight1 } from './collageHeight';

/**
 * Update proGallery height with slider layout
 * @param {Number} widgetHeight - height of all widget without this gallery.
 * @param {String} type - type of gallery ( HASHTAG / FEED ).
 */
const updateGridHeight = (widgetHeight, type) => (dispatch) => {
  const {
    numberOfImagesPerRow,
    numRows,
    imageMargin,
    galleryMargin,
    cubeRatio,
    isShowMoreBtn,
  } = getCurrentSettings(type);
  const {
    typeActionMoreData,
    countRowDisplay,
    isLoadedMore,
    items,
  } = getGalleryInfo(type);

  const padding = 2 * galleryMargin || 0;
  const widthGallery = window.innerWidth - padding;
  const countRowNeedToDisplay = isLoadedMore ? countRowDisplay : numRows;
  const itemWidth =
    (widthGallery - (numberOfImagesPerRow - 1) * imageMargin) /
    numberOfImagesPerRow;
  const itemHeight = itemWidth / cubeRatio;
  const rowHeight = itemHeight + imageMargin;
  let sectionHeight = rowHeight * countRowNeedToDisplay - imageMargin;
  const countMedias = items.length;
  let newHeight;

  const isDispalyAllMedias =
    countRowNeedToDisplay * numberOfImagesPerRow >= countMedias;

  // If count of media is smaller then (row * columns) that user selected
  if (isDispalyAllMedias) {
    // Fix rows and remove "Load More" btn
    const countRowNeedToAddNow = Math.ceil(countMedias / numberOfImagesPerRow);
    sectionHeight = rowHeight * countRowNeedToAddNow - imageMargin;
  }

  newHeight = sectionHeight + padding + DEFAULT_SHOW_MORE_HEIGHT;

  const isDispalyShowMoreBtn = isShowMoreBtn && !isDispalyAllMedias;
  if (isDispalyShowMoreBtn && imageMargin < 22) {
    newHeight = newHeight - 20;
  }

  const heightShowMoreNeedToRemove = isDispalyShowMoreBtn
    ? 0
    : DEFAULT_SHOW_MORE_HEIGHT;

  const isGeneralError =
    widgetHeight + newHeight - heightShowMoreNeedToRemove < 0 ? 270 : 0;
  window.Wix.setHeight(
    Math.max(0, widgetHeight + newHeight - heightShowMoreNeedToRemove + isGeneralError),
  );

  dispatch({
    type: typeActionMoreData,
    payload: {
      rowHeight,
      isDispalyShowMoreBtn,
      heightShowMoreNeedToRemove,
      sectionHeight,
      height: newHeight,
      padding,
    },
  });
};

/**
 * Update proGallery height with slider layout
 * @param {Number} widgetHeight - height of all widget without this gallery.
 * @param {String} type - type of gallery ( HASHTAG / FEED ).
 */
const updateSliderHeight = (widgetHeight, type) => (dispatch) => {
  const { typeActionMoreData } = getGalleryInfo(type);
  const { imageMargin, countItemsSlider, galleryMargin } = getCurrentSettings(
    type,
  );

  const padding = 2 * galleryMargin || 0;
  const widthGallery = window.innerWidth - padding;
  const itemWidth =
    (widthGallery - (countItemsSlider - 1) * imageMargin) / countItemsSlider;
  const itemHeight = itemWidth + padding;

  window.Wix.setHeight(widgetHeight + itemHeight);
  dispatch({
    type: typeActionMoreData,
    payload: {
      rowHeight: itemHeight,
      height: itemHeight,
      heightShowMoreNeedToRemove: 0,
    },
  });
};

/**
 * Return header height with padding
 */
const getHeaderheight = () => {
  const { profileHeaderHeight } = store.getState().appReducer;

  if (profileHeaderHeight != null) {
    if (profileHeaderHeight === 0) {
      return profileHeaderHeight;
    }
    const headerHeightWithPadding = profileHeaderHeight
      ? profileHeaderHeight
      : 0;
    return headerHeightWithPadding;
  }

  return null;
};

/**
 * Return header height with padding
 */
const getTitleHashtagheight = () => {
  const { titleHashtagHeight } = store.getState().appReducer;

  const title = document.getElementById('hashtagTitle');
  if (title) {
    const style = window.getComputedStyle(title);
    const marginTitle =
      parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    return titleHashtagHeight + marginTitle;
  }
  return titleHashtagHeight;
};

/**
 * Get info of gallery by type
 * @param {String} type - type of gallery ( HASHTAG / FEED ).
 */
export const getGalleryInfo = (type) => {
  const {
    medias,
    hashtagsData,
    isConnected,
    isBusinessApp,
    isMobile,
    isLoadingMedias,
  } = store.getState().appReducer;
  const { feed, hashtags } = store.getState().galleryReducer;
  const {
    isDisplayImagesFeed,
    isDisplayHashtagsFeed,
    m_isDisplayImagesFeed,
    m_isDisplayHashtagsFeed,
    layoutType,
    galleryLayoutHashtag,
    m_galleryLayout,
    m_galleryLayoutHashtag,
  } = store.getState().settingsReducer;

  const isDisplayFeed = isBusinessApp ? isMobile ? m_isDisplayImagesFeed : isDisplayImagesFeed : true;
  const isDisplayHashtag =
    (isMobile ? m_isDisplayHashtagsFeed : isDisplayHashtagsFeed) &&
    isBusinessApp;
  switch (type) {
    case GALLERY_TYPES.FEED:
      return {
        typeActionMoreData: ON_CHANGE_FEED_GALLERY,
        styleParamsByLayout: STYLE_PARAMS_BY_LAYOUTS,
        otherGalleryHeight:
          hashtags.height - hashtags.heightShowMoreNeedToRemove,
        isDisplayGallery: isDisplayFeed,
        galleryLayout: isMobile ? m_galleryLayout : layoutType,
        items: medias,
        isLoadingMedias,
        ...feed,
      };
    case GALLERY_TYPES.HASHTAG:
      return {
        typeActionMoreData: ON_CHANGE_HASHTAG_GALLERY,
        styleParamsByLayout: STYLE_PARAMS_BY_LAYOUTS_HASHTAG,
        otherGalleryHeight: feed.height - feed.heightShowMoreNeedToRemove,
        isDisplayGallery: isDisplayHashtag,
        galleryLayout: isMobile ? m_galleryLayoutHashtag : galleryLayoutHashtag,
        items: hashtagsData,
        ...hashtags,
      };
    default:
      break;
  }
};

const getLoaderMediasHeight = (widgetHeight, type) => (dispatch) => {
  const { typeActionMoreData } = getGalleryInfo(type);

  window.Wix.setHeight(Math.max(0, widgetHeight + LOADING_MEDIAS_HEIGHT));
  dispatch({
    type: typeActionMoreData,
    payload: {
      height: LOADING_MEDIAS_HEIGHT,
    },
  });
};

const getEmptyAccountHeight = (widgetHeight, viewMode, type) => (dispatch) => {
  if (viewMode !== 'editor') {
    return;
  }
  const { typeActionMoreData } = getGalleryInfo(type);
  window.Wix.setHeight(Math.max(0, widgetHeight + EMPTY_ACCOUNT_HEIGHT));
  dispatch({
    type: typeActionMoreData,
    payload: {
      height: EMPTY_ACCOUNT_HEIGHT,
    },
  });
};

/**
 * Calculate proGalllery height by layout type (Grid, Slider, Collage)
 */
export const calculateGalleryHeight = (type) => (dispatch) => {
  const { isEmptyAccount, viewMode } = store.getState().appReducer;
  const headerHeightWithPadding = getHeaderheight();
  const titleHashtagHeight = getTitleHashtagheight();
  const {
    otherGalleryHeight,
    typeActionMoreData,
    isDisplayGallery,
    galleryLayout,
    isLoadingMedias,
  } = getGalleryInfo(type);
  const widgetHeight =
    headerHeightWithPadding + titleHashtagHeight + otherGalleryHeight;
  // Check if header loaded
  if (headerHeightWithPadding != null) {
    // Check if need to display gallery
    if (!isDisplayGallery) {
      // If not display gallery
      window.Wix.setHeight(Math.max(0, widgetHeight));
      dispatch({
        type: typeActionMoreData,
        payload: {
          height: 0,
          heightShowMoreNeedToRemove: 0,
        },
      });
    } else if (isLoadingMedias) {
      dispatch(getLoaderMediasHeight(widgetHeight, type));
    } else if (isEmptyAccount && type === GALLERY_TYPES.FEED) {
      dispatch(getEmptyAccountHeight(widgetHeight, viewMode, type));
    } else {
      // If need to display gallery - update gallery height
      switch (galleryLayout) {
        case LAYOUTS.GRID:
          dispatch(updateGridHeight(widgetHeight, type));
          break;
        case LAYOUTS.COLLAGE:
          dispatch(updateCollageHeight1(widgetHeight, type));
          break;
        case LAYOUTS.SLIDER:
          dispatch(updateSliderHeight(widgetHeight, type));
          break;
        default:
          break;
      }
    }
  }
};

/**
 * Update height of all gallery on widget (HASHTAG & FEED)
 */
export const reloadAllGallery = () => (dispatch) => {
  dispatch(calculateGalleryHeight(GALLERY_TYPES.FEED));
  dispatch(calculateGalleryHeight(GALLERY_TYPES.HASHTAG));
};
